export const environment={
	production:false,
	apiServer:{
		url:'https://api-test.benditagrow.com'
	},
	webServer:{
		url:'https://www-test.benditagrow.com'
	},
	adminServer:{
		url:'https://admin-test.benditagrow.com'
	}
};




